<template>
	<view @click.stop="cancel($event)" class="chineseverify_container " v-if="showPopup" >
		<view class="chineseverify_content ">
			
			
			<view class="chineseverify_head chineseverify_title-padding hidden">
				<slot name="chineseverify_head"> 验证操作 </slot>
			</view>
			
			
			<view class="chineseverify_body ">
				<view id="verifyimg_box" ref="verifyimg_box" class="fullwidth relative verifyimg_box lineh1 overhide" style="line-height: 0;">
					<image @click.stop="selectWord" touchstart="selectWord" :src="chineseverifyImg"  mode="widthFix" class=" fullwidth autoheight lineh1 overhide"/>
					<view v-for="(item,index) in rightArr" class="absolute " :style="'top:'+item.top+'px;left:'+item.left+'px;'">
						<image :src="item.img"  mode="widthFix" class=" width24"/>
					</view>
				</view>
			</view>
			
			
			<view class="chineseverify_footer hidden">
				<view class="chineseverify_col" hover-class="chineseverify_hover" v-if="cancelText"
					@click.stop="cancel('cancel')">
					<text :style="cancelStyle" class="chineseverify_row-text">{{cancelText}}</text>
				</view>
				<view :style="confirmStyle" class="hidden chineseverify_col chineseverify_confirm"
					hover-class="chineseverify_hover" @click.stop="confirm">
					<text :style="confirmStyle" class="chineseverify_row-text">{{confirmText}}</text>
				</view>
			</view>
		</view>
	</view>
</template>
<script>
	export default {
		name: 'chinese_verify',
		props: {
			//默认是否显示
			showPopup: {
				type: Boolean,
				default: false
			},
			//取消按钮文字
			cancelText: {
				type: String,
				default: '取消'
			},
			//取消样式
			cancelStyle: {
				type: [String, Object]
			},
			//确定按钮文字
			confirmText: {
				type: String,
				default: '确定'
			},
			//确定样式
			confirmStyle: {
				type: [String, Object]
			},
			//阻止点击对话框外侧锁屏
			disableScreenClick: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				phone:"",
				smsCode:"",//用于证明手机号拥有
				verifyCode:"",//用于证明不是机器操作
				windowHeight:0,
				chineseverifyImg:"",
				imgBoxTop:0,
				imgBoxLeft:0,
				index:0,
				rightArr:[],
				windowTop:0,
				errorCount:0,//错误次数
			}
		},
		methods: {
			confirm() {
				uni.$emit('confirm');
			},
			cancel(e) {
				console.log(e);
				e.preventDefault();
				uni.$emit('cancelChineseVerify');
			},
			callback(d) {
				// 数据恢复
				this.rightArr=[];
				this.index=0;
				//回调
				uni.$emit('chineseVerifySuccessCallback',d);
			},
			getVerifyCode(phone){
				console.log("组件 getVerifyCode");
				//数据恢复
				this.rightArr=[];
				this.index=0;
				this.chineseverifyImg="";
				this.errorCount=0;
				this.phone=phone;
				
				this.$axios.request({
					url: window.$config.url.getVerifyCode,
					data: {phone:phone}
				})
				.then(res => {
					console.log("ppp",res);
					if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
						this.chineseverifyImg=res.data.img;
						this.onceStr=res.data.onceStr;
						
					}else if(!!res.msg==true){
						uni.showToast({ title:res.msg,icon:"none" });
					}else{
						uni.showToast({ title:"不成功",icon:"none" });
					}
				});
			},
			selectWord(e){
				console.log(e);
				var that=this;
				
				e.preventDefault();
				
				if(that.errorCount>5){
					that.getVerifyCode(that.phone);return;
				}
				that.errorCount=that.errorCount+1;
				
				var boxLeft=e.target.offsetLeft;
				var boxTop=e.target.offsetTop;
				
				var x=e.touches[0].clientX;
				var y=e.touches[0].clientY;
				
				//图片size
				that.getSize(".verifyimg_box").then(function(d){
					
					if(d.code!=window.$config.resCode.SUCCESS){
						uni.showToast({ title:"不成功",icon:"none" });
						return;
					}
					var imgW=d.data.width;
					var imgH=d.data.height;
					// #ifdef APP-PLUS || MP
					boxLeft=d.data.left;
					boxTop=d.data.top;
					// #endif
					
					
					//H5，windowHeight和点击坐标,均不含windowTop,但图片居中计算时含windowTop
					boxTop=(that.windowHeight+that.windowTop-imgH)/2-that.windowTop;
					boxLeft=(that.windowWidth-imgW)/2;
					console.log("boxTop=="+boxTop+";boxLeft=="+boxLeft);
					
					
					//请求
					var x1=x-boxLeft;//图片位置x
					var y1=y-boxTop;//图片位置y
					
					//转比例
					var phone=that.phone;
					var params={
						phone:phone,
						onceStr:that.onceStr,
						x:Math.round(x1/imgW*100),
						y:Math.round(y1/imgH*100),
						index:that.index
						};
					console.log(
						"屏幕尺寸："+that.windowWidth+"__"+that.windowHeight
						+" img尺寸："+imgW+"__"+imgH
						+" 点击坐标："+x1+"__"+y1
						+" 点击比例："+Math.round(x1/imgW*100)+"__"+Math.round(y1/imgH*100)
						+" 顶部bar高："+that.windowTop
						);
					that.$axios.request({
						url: window.$config.url.doVerify,
						data: params
					})
					.then(res => {
						if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
							that.rightArr.push({img:"/static/selected.png",top:y1-12,left:x1-12});
							if(that.index==3){
								that.verifyCode=res.data;
								uni.showToast({ title:"ok",icon:"none" });
								that.callback({verifyCode:that.verifyCode});
							}
							that.index++;
							that.errorCount=0;
							
						}else if(!!res.msg==true){
							if(res.code==window.$config.resCode.VERIFY_TIMEOUT){
								that.getVerifyCode(that.phone);
							}
							uni.showToast({ title:res.msg,icon:"none" });
						}else{
							uni.showToast({ title:"不成功",icon:"none" });
						}
					});
					
				}).catch(function(e){
					console.log(e);
				});
				
				
				
				
			},
			
			
			/**
			 * 获取组件宽高
			 * @param {Object} element ".class or #id"
			 */
			getSize(element){
				
				  return new Promise((resolve, reject) => {
					  
					  //H5端获得控件的宽度
					  // #ifdef H5
					  console.log("in H5");
					  let width= this.$el.querySelector(element).clientWidth;
					  let height= this.$el.querySelector(element).clientHeight;
					  resolve({code:1000,msg:"成功",data:{width:width,height:height}});return;
					  // #endif
					  
					  
					  //微信小程序获得控件的宽度
					  // #ifdef APP-PLUS || MP
					//   console.log("MP || APP_PLUS");
					//   let width= 0;let height= 0;
					//   var query = this.createSelectorQuery();
					//   query.select(element).boundingClientRect(
					//   	function(rect){
					// 		console.log(rect);
					//   		if(rect.width){
					//   		  width=rect.width;
					//   		  height=rect.height;
					//   		  resolve({code:1000,msg:"成功",data:rect});return;
					//   		}
					//   	}).exec();
					  // #endif
					  
					  
					  //reject({code:9999,msg:"获得控件宽度不成功",data:null});return;
					  
				});
											
				
				
			}
		},
		mounted() {
			
			console.log('chineseverify mounted');
			var sysinfo=uni.getSystemInfoSync();
			this.windowTop=sysinfo.windowTop || 0;
			this.windowWidth=sysinfo.windowWidth || 0;
			this.windowHeight=sysinfo.windowHeight || 0;
			console.log(sysinfo);
			console.log(this.showPopup);
			
			if(this.showPopup)this.getVerifyCode();
			
			// #ifdef APP-PLUS
			//在普通的 H5+ 项目中，需要使用 document.addEventListener 监听原生扩展的事件。
			//uni-app 中，没有 document。可以使用 plus.globalEvent.addEventListener 来实现（注意manifest中需开启新编译器，即自定义组件模式"usingComponents":true）。
			// plus.globalEvent.addEventListener('click', function(e){
			// 	console.log("kkkkkkk-----");console.log(e);
			// });
			// #endif
			
			
			
		}
	}
</script>
<style scoped>
	.chineseverify_container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.9);
		transition: all 5s;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.chineseverify_content {
		width: 90%;
		xxborder-radius: 26rpx;
		background: none;
		overflow: hidden;
		animation: fadeZoom .15s linear;
		max-width: 500px;
	}

	.chineseverify_head {
		padding: 30rpx 30rpx 0;
		text-align: center;
		color: #000;
		font-size: 17px;
		font-weight: 700;
	}

	.chineseverify_title-padding {
		padding-bottom: 30rpx;
	}

	.chineseverify_body {
		overflow: auto;
		xxxpadding: 40rpx 30rpx;
		font-size: 15px;
		color: #000;
		text-align: center;
		
	}

	.chineseverify_footer {
		display: flex;
		position: relative;
		text-align: center;
		font-size: 17px;
		line-height: 100rpx;
		color: #007AFF;
		border-top: 0.5px solid rgba(9, 20, 31, 0.13);
	}

	.chineseverify_col {
		flex: 1;
		width: 100%;
		position: relative;
	}

	.chineseverify_col:first-child::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		border-right: 1px solid rgba(9, 20, 31, 0.13);
		transform: scaleX(.36);
	}

	.chineseverify_confirm {
		color: rgb(0, 122, 255);
	}

	.chineseverify_hover {
		background-color: #f2f2f2;
	}


	.chineseverify_footer::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		border-top: 0.5px solid rgba(9, 20, 31, 0.13);
		transform: scaleY(.36);
	}


	@keyframes fadeZoom {
		0% {
			transform: scale(.7);
			opacity: .6;
		}

		80% {
			transform: scale(1.2);
			opacity: .3;
		}

		100% {
			transform: scale(1);
			opacity: 1;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/chineseverify/chineseverify.vue